import React from "react";
import { QuestionType } from "../../../service/service";
import { OrderTopicType } from ".";
import { PaperParams } from "../../../service/homework";

export interface HomeworkContextProps {
    paperId: string;
    paperParams: PaperParams;
    lockEdit: boolean; // 禁止编辑
    topics: OrderTopicType[];
    isPublish: boolean;
    isHomeworkComplete: boolean;
    setTopics: (topics: OrderTopicType[]) => void;
    addTopic: (type: QuestionType) => void;
    loadPaperData: () => void;
}

const HomeworkContext = React.createContext<HomeworkContextProps>({
    paperId: "",
    paperParams: {
        courseNo: "",
        courseSeq: "",
        week: "",
        weekTime: "",
        section: "",
        continunity: "",
        weekTimeId: ""
    },
    lockEdit: false,
    isPublish: false,
    isHomeworkComplete: false,
    topics: [],
    setTopics: () => null,
    addTopic: () => null,
    loadPaperData: () => null
});

export default HomeworkContext;
